import React from 'react';
import { Outlet } from 'react-router-dom';
import LandingNavbar from './LandingNavbar';
import LandingFooter from './LandingFooter';
import '../../../styles/components/landing/LandingLayout.css';

const LandingLayout = ({ children }) => {
  return (
    <div className="landing-layout">
      <LandingNavbar />
      <main className="landing-main">
        {/* Use children if provided, otherwise use Outlet for nested routes */}
        {children || <Outlet />}
      </main>
      <LandingFooter />
    </div>
  );
};

export default LandingLayout;